@for(provider of providers; track provider.providerId){

<form (ngSubmit)="openIdConnect(provider.providerId)">

  <div *ngIf="provider?.msgHeader !== ''" class="msg-header" [innerHTML]="provider?.msgHeader | safe">
  </div>

  @switch (provider?.providerButtonType) {
  @case ('image-only') {
  <button type="submit" class="open-id-button only-image">
    <img class="img-normal" [src]="provider?.providerButtonImage" [alt]="'S\'identifier avec '+provider?.providerName">
    <img class="img-hover" [src]="provider?.providerButtonHoverImage" alt="" aria-hidden="true">
  </button>

  }
  @case ('icon+label') {
  <button type="submit" mat-raised-button color="primary" class="open-id-button with-logo">
    <div class="logo-with-label">
      <img class="open-id-logo" [src]="provider?.providerButtonIcon">
      <span *ngIf="provider?.providerButtonLabel && provider?.providerButtonLabel !== ''  else defaultLabel"
        [innerHTML]="provider?.providerButtonLabel |safe">
      </span>
    </div>
  </button>
  }
  @case ('label-only') {
  <button type="submit" mat-raised-button color="primary" class="open-id-button">
    <span *ngIf="provider?.providerButtonLabel && provider?.providerButtonLabel !== ''  else defaultLabel"
      [innerHTML]="provider?.providerButtonLabel |safe">
    </span>
  </button>
  }
  }

  <ng-template #defaultLabel>
    <span>S'identifier avec {{provider?.providerName}}</span>
  </ng-template>

  <div *ngIf="provider?.linkInfoLabel !== '' && provider?.linkInfoUrl !== ''" class="">
    <a [href]="provider?.linkInfoUrl" target="_blank">
      {{provider?.linkInfoLabel}}
      <i class="fas fa-external-link-alt"></i>
    </a>
  </div>
</form>
}